export const subtitles = {
    "1": {
        "startTime": 2.3,
        "endTime": 5.0,
        "transcript": "Is that my mic? It is my mic.",
        "translation": "Is that my mic? It is my mic."
    },
    "2": {
        "startTime": 8.9,
        "endTime": 10.0,
        "transcript": "This one's yours, this one. (Oh, I see.)",
        "translation": "This one's yours, this one. (Oh, I see.)"
    },
    "3": {
        "startTime": 10.9,
        "endTime": 15.8,
        "transcript": "Ready? (Yaa. Maybe, well, yaa, okay.)",
        "translation": "Ready? (Yes. Maybe, well, yes, okay.)"
    },
    "4": {
        "startTime": 16.0,
        "endTime": 23.4,
        "transcript": "For the record, qalarulluku Johnny K. Guy, Kuigglugmiu.",
        "translation": "For the record, talking to Johnny K. Guy from Kwethluk."
    },
    "5": {
        "startTime": 25.0,
        "endTime": 27.5,
        "transcript": "Qavarliar? (Qavarliaq, yaa.)",
        "translation": "Qavarliar? (Qavarliaq, yes.)"
    },
    "6": {
        "startTime": 27.6,
        "endTime": 30.4,
        "transcript": "Alright, Qavarliaq, yaa.",
        "translation": "Alright, Qavarliaq, okay."
    },
    "7": {
        "startTime": 30.5,
        "endTime": 35.0,
        "transcript": "K-aamek ayagnirluni pilartuq. [?] (Okay. Okay.)",
        "translation": "It starts with a K [in the old orthography]. [?] (Okay. Okay.)"
    },
    "8": {
        "startTime": 36.0,
        "endTime": 52.0,
        "transcript": "Kitak' ak'a tamaani ayagyuallerpeni… (Catularceta-qaa?)",
        "translation": "Now, when you were young back then… (You mean what we used to eat?)"
    },
    "9": {
        "startTime": 52.1,
        "endTime": 56.8,
        "transcript": "Nuu, cassulallruceci ingrinun?",
        "translation": "No, what did youpl go to the mountains for?"
    },
    "10": {
        "startTime": 57.0,
        "endTime": 64.0,
        "transcript": "Ingrini tuntunek calilallruuq atalpt imna Guy-aq.",
        "translation": "Our late father, Guy, used to work with reindeer in the mountains."
    },
    "11": {
        "startTime": 66.5,
        "endTime": 72.0,
        "transcript": "Tuntut murilkelluki caliaqluki.",
        "translation": "He would work herding reindeer."
    },
    "12": {
        "startTime": 73.0,
        "endTime": 83.0,
        "transcript": "Makut-qaa yuut tuntunek tamakunek ellait, ellmeng pikameggnek pingqelallruut?",
        "translation": "Did those people have their own reindeer that they owned themselves?"
    },
    "13": {
        "startTime": 83.1,
        "endTime": 86.5,
        "transcript": "Nallunailkutangqelallruut-llu-qaa tamakut tuntut?",
        "translation": "Did those reindeer also have identifying marks?"
    },
    "14": {
        "startTime": 86.6,
        "endTime": 91.0,
        "transcript": "Tuntut tamakut government-artaunilallruit",
        "translation": "They used to say those reindeer belonged to the government"
    },
    "15": {
        "startTime": 91.1,
        "endTime": 100.0,
        "transcript": "Tau͡gaam maagiaqluteng uksuarmi ciutaitnek tuntut.",
        "translation": "But they would mark reindeer ears in the fall."
    },
    "16": {
        "startTime": 100.4,
        "endTime": 102.9,
        "transcript": "Tuntunek-ll' akingluteng.",
        "translation": "They also got paid for [herding] reindeer."
    },
    "17": {
        "startTime": 103.6,
        "endTime": 110.0,
        "transcript": "Akiliruarturluk' tau͡gken tayima alairpek'nateng maa-i.",
        "translation": "They would get paid, but they would never appear [in person]."
    },
    "18": {
        "startTime": 110.8,
        "endTime": 112.0,
        "transcript": "Ii-i.",
        "translation": "I see."
    },
    "19": {
        "startTime": 114.8,
        "endTime": 119.0,
        "transcript": "Tamakut tuntut-qaa amllelallruut ak'a tamaani?",
        "translation": "Were there a lot of reindeer back then?"
    },
    "20": {
        "startTime": 120.0,
        "endTime": 126.5,
        "transcript": "Amllessiyaagpek'nateng-gguq ciuqlirmi, kinguqvaarni-ll' maani amlleriluteng urluteng.",
        "translation": "They said there weren't too many at first, then they increased later and got dirty."
    },
    "21": {
        "startTime": 127.0,
        "endTime": 128.9,
        "transcript": "Governement-artarnek piaqluteng.",
        "translation": "The [herded] government reindeer."
    },
    "22": {
        "startTime": 129.0,
        "endTime": 137.5,
        "transcript": "Makunek, makunek-llu aungluteng amaken Nome-amek ukatmurtellrianek tuntupianek.",
        "translation": "They also got blood from these caribout coming here from Nome."
    },
    "23": {
        "startTime": 139.0,
        "endTime": 143.7,
        "transcript": "Ciin maa-i-rpak nang'at tamakut?",
        "translation": "Why have they depleted now?"
    },
    "24": {
        "startTime": 143.8,
        "endTime": 146.5,
        "transcript": "Naamell'. Keglunret-wa nangllikait.",
        "translation": "I don't know. Wolves probably depleted them."
    },
    "25": {
        "startTime": 146.6,
        "endTime": 154.4,
        "transcript": "Ukatmun [?] maa-i amllerilriit maani tuntut tekitellret amaken Nome-amek.",
        "translation": "There are now a lot of reindeer that have come over from Nome."
    },
    "26": {
        "startTime": 154.5,
        "endTime": 158.5,
        "transcript": "Amlleriata amani ukatmurrluteng tailriit.",
        "translation": "Because they've increased over there, they've come here."
    },
    "27": {
        "startTime": 161.3,
        "endTime": 170.8,
        "transcript": "Tua-ll' makut, imkut qanrutkeqa'arki… I can't.",
        "translation": "And then, please talk about these… I can't."
    },
    "28": {
        "startTime": 172.9,
        "endTime": 176.5,
        "transcript": "Angulten makut, imkut qasgi.",
        "translation": "What you were born in time to see, the community house."
    },
    "29": {
        "startTime": 177.0,
        "endTime": 187.5,
        "transcript": "Maani yuratullruut yaani qasgi'rpagluteng Kuigglugmiut yaani qukaqvani agayuvillrem kiakaraani.",
        "translation": "They used to have Yup'ik dance festivals here with a huge community house in Kwethluk, over there in the middle upriver from the old church."
    },
    "30": {
        "startTime": 188.4,
        "endTime": 192.5,
        "transcript": "Qasgi'rpagluteng, yuraraqluteng.",
        "translation": "They had a huge community house and would have Yup'ik dance festivals."
    },
    "31": {
        "startTime": 193.5,
        "endTime": 198.7,
        "transcript": "Tuani-qaa alerquutnek qalartelallruut angukara'urluut?",
        "translation": "Would the old men talk about traditional instructions there?"
    },
    "32": {
        "startTime": 199.0,
        "endTime": 201.0,
        "transcript": "Niiteksaitanka wiinga.",
        "translation": "I haven't heard them."
    },
    "33": {
        "startTime": 204.5,
        "endTime": 212.0,
        "transcript": "Tau͡gaam Akiacurmi-llu yuraryarturaqluteng Akiacuarmun maaken.",
        "translation": "But they would also go to dance festivals in Akiachak from here."
    },
    "34": {
        "startTime": 212.8,
        "endTime": 215.5,
        "transcript": "Uksuarmi-w' tau͡gaam kiagmi.",
        "translation": "At least in the winter and summer."
    },
    "35": {
        "startTime": 216.5,
        "endTime": 218.7,
        "transcript": "Kelegluki-qaa pilallruit?",
        "translation": "Would they invite them?"
    },
    "36": {
        "startTime": 218.8,
        "endTime": 226.0,
        "transcript": "Kelegluki. Makumiut Akiacuarmiut kelegluki qasgiliyartuusqelluki.",
        "translation": "They invited them. The people from Akiachak invited the people from here to go make a community house."
    },
    "37": {
        "startTime": 227.2,
        "endTime": 235.5,
        "transcript": "Tua-i-ll' Akiacuarmi qasgililuteng qasgi'rpagmek imkunek [?] petugluki.",
        "translation": "And then they made a huge community house in Akiachak tying it with [?]."
    },
    "38": {
        "startTime": 239.2,
        "endTime": 242.0,
        "transcript": "Calallruat qasgiaqameng?",
        "translation": "What would they do when they went to the community house?"
    },
    "39": {
        "startTime": 242.5,
        "endTime": 249.0,
        "transcript": "Yurarluteng. Atakuani kalukirluteng waten itrulluki piciatun",
        "translation": "They Yup'ik danced. They would have a feast that evening, bring in various things like this"
    },
    "40": {
        "startTime": 249.3,
        "endTime": 256.0,
        "transcript": "Aminek, caqukat-ll' amiitnek, tuntut-llu.",
        "translation": "Hides, hides for containers, and caribou."
    },
    "41": {
        "startTime": 258.4,
        "endTime": 265.0,
        "transcript": "Yuraulluki kapkaananek-llu, canek-wa tua-i lumarrarnek-llu.",
        "translation": "They brought those to dance festivals, including animal traps, various things, and cloth."
    },
    "42": {
        "startTime": 268.5,
        "endTime": 275.0,
        "transcript": "Niitelallruuten-qaa ak'a tamaani anguyalallernek?",
        "translation": "Have you heard about wars a long time ago?"
    },
    "43": {
        "startTime": 276.0,
        "endTime": 280.0,
        "transcript": "Niitelallruyaaqellrianga-w' tau͡gaam nallukenka.",
        "translation": "I used to hear about them, but I don't know them."
    },
    "44": {
        "startTime": 280.9,
        "endTime": 288.0,
        "transcript": "Maani anguyagnilallrukait Yuullgutmeggnun kiatmun tuaten Kusquqvagmi.",
        "translation": "They say they had wars here against their fellow Yupiit even going upriver on the Kuskokwim."
    },
    "45": {
        "startTime": 289.4,
        "endTime": 295.0,
        "transcript": "Tau͡gaam wii elisnganrilama nalluanka qalamciksiyaaksailatki.",
        "translation": "But because I'm not knowledgable, I don't know about them because they didn't talk about them too much."
    },
    "46": {
        "startTime": 296.0,
        "endTime": 300.5,
        "transcript": "Imna-qaa makumiulleq Aavaaq angullruan?",
        "translation": "Were you born in time to see Aavaaq who used to live here?"
    },
    "47": {
        "startTime": 300.8,
        "endTime": 315.0,
        "transcript": "Angullruaqa. Uani enengqelallruuq neqlillret au͡gkut akiatni ualirnermi ekviim qaingani Aavaaq.",
        "translation": "I was born in time to see him. Aavaaq used to have a house downriver across and downriver from the fishcamp on the riverbank."
    },
    "48": {
        "startTime": 321.0,
        "endTime": 324.0,
        "transcript": "Im'u, yuungcarteńgullruuq-qaa?",
        "translation": "Well, was he a healer?"
    },
    "49": {
        "startTime": 324.8,
        "endTime": 329.5,
        "transcript": "Qanyuitellruuq tau͡gaam elucira'arturluni qallataqluni.",
        "translation": "He didn't speak, but he talked with gestures."
    },
    "50": {
        "startTime": 330.0,
        "endTime": 332.0,
        "transcript": "Qaneneq nalluluku.",
        "translation": "He didn't know how to talk."
    },
    "51": {
        "startTime": 333.0,
        "endTime": 334.9,
        "transcript": "Angalkuuvkenani-qaa?",
        "translation": "Was he not a shaman?"
    },
    "52": {
        "startTime": 335.0,
        "endTime": 337.0,
        "transcript": "Angalkuuvkenani.",
        "translation": "He wasn't a shaman."
    },
    "53": {
        "startTime": 338.0,
        "endTime": 343.0,
        "transcript": "Calinguaryunqeggluni. Muragnek tuaten nuyuuruciluni.",
        "translation": "He liked to make little things. He even made wooden hairbrushes."
    },
    "54": {
        "startTime": 345.5,
        "endTime": 348.0,
        "transcript": "Tua-i-w' calinguarturluni.",
        "translation": "He always made little things."
    },
    "55": {
        "startTime": 349.5,
        "endTime": 357.5,
        "transcript": "Man'a kuigci Kuigglugmek at'lek naken tauna ateq pugtellruceciu?",
        "translation": "Yourpl river Kuiggluk here, where did youpl come up with that name?"
    },
    "56": {
        "startTime": 358.0,
        "endTime": 366.5,
        "transcript": "Wiinga nalluaqa naken, tau͡gaam ateqluku nutem Kuiggluk niitela'arqa.",
        "translation": "I don't know from where, but I heard it's always been called Kuiggluk."
    },
    "57": {
        "startTime": 366.8,
        "endTime": 372.5,
        "transcript": "Maa-i-gguq Kuiggluum qaingani enet makut uitaut kuillrem",
        "translation": "They say that these houses are on the old Kuiggluk [river path]"
    },
    "58": {
        "startTime": 374.0,
        "endTime": 380.0,
        "transcript": "Tamaani kuilleq pava-i Kuigglugmiut keluatni.",
        "translation": "That old river inland from Kwethluk."
    },
    "59": {
        "startTime": 382.0,
        "endTime": 384.5,
        "transcript": "Kuillrunilaqiit-wa.",
        "translation": "They say it was an old river."
    },
    "60": {
        "startTime": 388.0,
        "endTime": 400.0,
        "transcript": "Ayagyuallerpeni-qaa alerqualallruatgen pissuryaraqataraqavet atu'urkavnek yuilqumi?",
        "translation": "When you were young, would they instruct you on things you would need to use in the wilderness when you were going to go hunt?"
    },
    "61": {
        "startTime": 401.0,
        "endTime": 406.0,
        "transcript": "Alerqualallruatnga canek tau͡gaam maqarqelluki",
        "translation": "They used to instruct me to dress warmly"
    },
    "62": {
        "startTime": 406.8,
        "endTime": 418.0,
        "transcript": "Maqarqellua ayaasqellua piarkaunilua. Qerrutarkaunilua-llu yuilqumi tarrisnginanemni.",
        "translation": "That I had to travel in warm clothes. They also said I would be cold as I wandered in the wilderness."
    },
    "63": {
        "startTime": 419.5,
        "endTime": 426.9,
        "transcript": "Malingqelallruiceci-llu-qaa anirturcuutekavceńek canek?",
        "translation": "Did they also tell youpl to bring things that would save youpl?"
    },
    "64": {
        "startTime": 427.0,
        "endTime": 438.5,
        "transcript": "Yaa, malilirluta taquarrarluta-llu neqkarramteńek qaill' pinayukluta yuilqumi ayainanemteńi.",
        "translation": "Yes, we would bring things, and have some food provisions in case anything happened as we traveled in the wilderness."
    },
    "65": {
        "startTime": 441.0,
        "endTime": 447.7,
        "transcript": "Makunek-mi qalartelalriit ilait ayarunek?",
        "translation": "What about walking staffs that some people talk about?"
    },
    "66": {
        "startTime": 449.0,
        "endTime": 464.0,
        "transcript": "Ayarulgirturluta-llu. Ciunerput-gguq waten tugqaqluku kuigni qeraasqaqluta kitnayukluta-gguq.",
        "translation": "We always had staffs too. They said that we should cross rivers prodding it like this in case we should fall into the water."
    },
    "67": {
        "startTime": 466.0,
        "endTime": 472.0,
        "transcript": "Yaa, mat'um nalliini tamakut qanruyutellret ak'allauluki",
        "translation": "Yes, these days, those old pieces of traditional wisdom"
    },
    "68": {
        "startTime": 473.6,
        "endTime": 477.7,
        "transcript": "Ak'allaat-wa imkut yullret atulallrukait.",
        "translation": "The people back then used to adhere to them."
    },
    "69": {
        "startTime": 477.8,
        "endTime": 487.0,
        "transcript": "Yaa, ciumteńi yuurtellret ciuliallemta atulallruit ayarut.",
        "translation": "Yes, our ancestors who were born before us used staffs."
    },
    "70": {
        "startTime": 487.5,
        "endTime": 491.0,
        "transcript": "Ayarutgun-llu pissutullrullilriit uqiliimeng.",
        "translation": "They also probably hunted with staffs because they were quick on foot."
    },
    "71": {
        "startTime": 492.8,
        "endTime": 502.7,
        "transcript": "Maa-i-rpak-mi makut-qaa ayagyuat mikelngullraat tamakut yuut qanruyutek'lallrit niitnarqait?",
        "translation": "What about these young people, children, these days, should they listen to those pieces of Yup'ik wisdom?"
    },
    "72": {
        "startTime": 503.7,
        "endTime": 509.0,
        "transcript": "Niitnaqsaaqekait-wa, ayarulgirturluteng-llu tarritaqluteng.",
        "translation": "They should hear about them, and walk around with staffs."
    },
    "73": {
        "startTime": 509.5,
        "endTime": 516.0,
        "transcript": "Tau͡gaam tuaten piksailngat'lartut. Ilait ayaruitelartut.",
        "translation": "But they don't seem to do that. Some don't have staffs."
    },
    "74": {
        "startTime": 517.7,
        "endTime": 522.5,
        "transcript": "Elpeni-qaa makut ayagyuat mat'um nalliini",
        "translation": "To you, these young people these days"
    },
    "75": {
        "startTime": 523.0,
        "endTime": 531.5,
        "transcript": "Makut mikelngullraat maa-i-rpak tangvakten elpeni-qaa inerciigatut ak'allarmini?",
        "translation": "These children that you are seeing these days, are they more mischievous to you than before?"
    },
    "76": {
        "startTime": 532.0,
        "endTime": 534.9,
        "transcript": "Ciunganicetun ayuqenritut.",
        "translation": "They're not like before."
    },
    "77": {
        "startTime": 535.0,
        "endTime": 540.0,
        "transcript": "Inerciigalikaniirngat'lartut tangellrat man'a.",
        "translation": "They look like they're getting more mischievous."
    },
    "78": {
        "startTime": 541.0,
        "endTime": 545.5,
        "transcript": "Ciunganicetun inerquuteteng maligtaquvkenaki.",
        "translation": "They don't obey their admonishments like before."
    },
    "79": {
        "startTime": 547.0,
        "endTime": 549.0,
        "transcript": "Ciin tamana tuaten piyunga?",
        "translation": "Why does it seem to be like that?"
    },
    "80": {
        "startTime": 551.5,
        "endTime": 559.4,
        "transcript": "Naamell'. Umyugaata-w' pilallikait ellaita tuaten pinaluteng umyuarteqellrata.",
        "translation": "I don't know. It's probably their minds when they have the idea to do that."
    },
    "81": {
        "startTime": 560.8,
        "endTime": 569.0,
        "transcript": "Tayima-llu-wa aipaagni angayuqaita, aanaita, ataita-llu qalarucuirucamegteki waten ellillilriit.",
        "translation": "They've also probably become like this because their parents, mothers, and fathers do not teach them anymore."
    },
    "82": {
        "startTime": 569.5,
        "endTime": 570.5,
        "transcript": "Piyugnarquq.",
        "translation": "Probably."
    },
    "83": {
        "startTime": 570.6,
        "endTime": 576.0,
        "transcript": "Qalarutsiyaayuirutait maa-i yut'eng.",
        "translation": "They don't teach their children too much anymore."
    },
    "84": {
        "startTime": 576.1,
        "endTime": 582.4,
        "transcript": "Tamakunek iliini inerquraqluki tuaten pisqevkenaki, tamakunek-ll' atuusqevkenaki.",
        "translation": "They sometimes admonish them against doing that and against using those."
    },
    "85": {
        "startTime": 582.5,
        "endTime": 587.0,
        "transcript": "Inerqularyaaqluki tau͡gaam niisngaksaitaqluteng.",
        "translation": "They admonish them, but they don't listen."
    },
    "86": {
        "startTime": 589.0,
        "endTime": 594.0,
        "transcript": "Ciin-kiq tanem tua-i niisngayuirutat makut ayagyuat?",
        "translation": "I wonder why these young people are getting disobedient?"
    },
    "87": {
        "startTime": 597.8,
        "endTime": 608.5,
        "transcript": "Tua-i-w' qanruyuteteng niisngassiyaagpek'naki qanrucunaitellrata pillikait.",
        "translation": "It's probably because they don't listen to traditional wisdom and refuse instruction."
    },
    "88": {
        "startTime": 609.7,
        "endTime": 612.9,
        "transcript": "Tuaten pisqenrilengraateng tuaten piaqluteng.",
        "translation": "Even though they are told not to do it, they do."
    },
    "89": {
        "startTime": 613.5,
        "endTime": 618.5,
        "transcript": "Aipaagni-llu-wa tayima elitnaurviit makut ilalqalallikait.",
        "translation": "These schools are probably exacerbating that for them."
    },
    "90": {
        "startTime": 618.8,
        "endTime": 622.0,
        "transcript": "Elitnaurviit-llu makut navguryugluteng.",
        "translation": "These schools also get destroyed."
    },
    "91": {
        "startTime": 622.1,
        "endTime": 626.5,
        "transcript": "Makut kinguqliit ciuqlirmi avani tuaten etellrunritut.",
        "translation": "These descendants of before were not like that."
    },
    "92": {
        "startTime": 626.8,
        "endTime": 631.9,
        "transcript": "Maa-i tau͡gaam navguriyugluteng elitnaurvignek tuaten canek.",
        "translation": "But now, they destroy even schools, various things."
    },
    "93": {
        "startTime": 632.4,
        "endTime": 637.0,
        "transcript": "Enenek-llu yuilngurnek navguriyugluteng ping'ngut.",
        "translation": "They've also started destroyed unoccupied buildings."
    },
    "94": {
        "startTime": 639.0,
        "endTime": 646.6,
        "transcript": "Tayima-wa ilait makut-llu makumiuyagaat ayagyuat taringyuirutlilriit Yugcetun.",
        "translation": "Some of the young people from here probably do not understand Yup'ik anymore."
    },
    "95": {
        "startTime": 648.0,
        "endTime": 650.8,
        "transcript": "Qitevqurayaangameng-wa.",
        "translation": "Because the little ones now always speak English."
    },
    "96": {
        "startTime": 651.0,
        "endTime": 660.5,
        "transcript": "Nauwa ciuqlirmi Yugcetun, qitevvneq nallullrukiit tua-ll' elitnauryaurrluteng.",
        "translation": "Consider that [they spoke] Yup'ik before, not knowing English and then they started going to school."
    },
    "97": {
        "startTime": 661.0,
        "endTime": 670.5,
        "transcript": "Tua-ll' imkut qavaken qau͡gkumiullret Yugcetun, Yugcetun qanssiyaayuitut Yurialnguungameng-wa.",
        "translation": "And then the people from upriver do not speak Yup'ik too much because they're Upper Kuskokwim Athabascans."
    },
    "98": {
        "startTime": 671.0,
        "endTime": 681.3,
        "transcript": "Tau͡gaam Kass'acetun qallateng'e'rmeng, tavaq-qaa-llu qallatelteng taringelaqait Kass'acetun?",
        "translation": "But even though they speak English, do they really understand when they speak English?"
    },
    "99": {
        "startTime": 684.5,
        "endTime": 694.0,
        "transcript": "Man'a-qaa Yugcetun qalarcaraq, qaneryaraput wangkuta Yugcetun elpeni-qaa cagmarnarqenrituq?",
        "translation": "For you, should our speaking in Yup'ik, our Yup'ik language not be lost?"
    },
    "100": {
        "startTime": 695.0,
        "endTime": 698.5,
        "transcript": "Yugcetun cagmayunaituq qanelput.",
        "translation": "Our Yup'ik language should not be lost."
    },
    "101": {
        "startTime": 699.0,
        "endTime": 709.0,
        "transcript": "Kass'acetun-llu aukluku Yugcetun mumiggluku Kass'at qanellrat",
        "translation": "Couple it with English, translating what is said in English into Yup'ik"
    },
    "102": {
        "startTime": 710.0,
        "endTime": 721.0,
        "transcript": "Tamakut tuaten apqaulaitkut mumigtesqelluki, mumigutesqelluteng-llu Kass'at Yuunrilnguut makut wangkucicetun.",
        "translation": "Because they ask us to translate like that, and these Caucasians who aren't Yup'ik like us ask for translations."
    },
    "103": {
        "startTime": 722.0,
        "endTime": 726.0,
        "transcript": "Yuut-llu ilait qanerceciisqaqluteng Kass'anun.",
        "translation": "And some Yupiit ask for others to speak to Caucasians for them."
    },
    "104": {
        "startTime": 731.0,
        "endTime": 736.0,
        "transcript": "Makut ak'allaat yuut ilait qanlartut waten:",
        "translation": "Some of the old people say this:"
    },
    "105": {
        "startTime": 738.0,
        "endTime": 750.0,
        "transcript": "Maaten-gguq-qaa agayuviit tekiteqarraallratni maavet naaqiut ukunek Qaneryaranek igausngalrianek Bible-aanek aptukait.",
        "translation": "They said that when these churches first came, they ended up reading these written Qaneryarat, what they call the Bible."
    },
    "106": {
        "startTime": 751.5,
        "endTime": 753.4,
        "transcript": "Naaqait-gguq taringyaurrluki-llu-gguq.",
        "translation": "They said they read and started understanding them."
    },
    "107": {
        "startTime": 753.5,
        "endTime": 764.5,
        "transcript": "Maaten-gguq piit Yugtaat imkut ak'allat qaneryarait alerquutait-llu uniurtevkenaki pilallinikait.",
        "translation": "They realized that they were not different from the old Yup'ik wisdom and traditional isntructions."
    },
    "108": {
        "startTime": 764.6,
        "endTime": 768.6,
        "transcript": "Qaillun elpeni-qaa tamana tuaten tamana piciuguq?",
        "translation": "Is that true for you?"
    },
    "109": {
        "startTime": 769.0,
        "endTime": 771.0,
        "transcript": "Wangni-wa piciulria.",
        "translation": "It's true for me."
    },
    "110": {
        "startTime": 771.5,
        "endTime": 778.5,
        "transcript": "Alerquateteng maligtaquaqamegteki tuaten qanellritnek ciuliat",
        "translation": "When they obey those instructions that the ancestors taught"
    },
    "111": {
        "startTime": 779.0,
        "endTime": 792.7,
        "transcript": "Tayima man'a ellavut waten ciungani yugyanritlermini nuna mamtullrunritlilria",
        "translation": "When our earth here was not heavily populated back then, the land was probably thin"
    },
    "112": {
        "startTime": 792.8,
        "endTime": 805.0,
        "transcript": "Wall' ellavut, ellakun, ella cuqyutekluku qallatelallrulilriit yuut.",
        "translation": "Or the people probably talked gauging the weather."
    },
    "113": {
        "startTime": 811.5,
        "endTime": 826.5,
        "transcript": "Man'a-qaa qanruyuciuryaraq, yuut qanruyuciuryaraat makut makunun ayagyuanun nalluyagutnarqenrituq?",
        "translation": "Should we not forget passing on traditional wisdom, our Yup'ik way of passing on wisdom to our young people here?"
    },
    "114": {
        "startTime": 826.8,
        "endTime": 837.0,
        "transcript": "Nalluyagucunaitellria-wa qanruyun man'a waten ataminek wall'u allanek yugnek.",
        "translation": "A person should not forget traditional wisdom from his father or from other people."
    },
    "115": {
        "startTime": 840.0,
        "endTime": 859.0,
        "transcript": "Qanrutesqelluku mat'umek, tua-i-w' qaneryaraqluku man'a, ella, ella qaneryaraqluku.",
        "translation": "They should talk about it, traditional wisdom about nature, traditional wisdom about nature."
    },
    "116": {
        "startTime": 859.5,
        "endTime": 862.0,
        "transcript": "Erinakluku-w' tua-i pilallilriit.",
        "translation": "They're probable the voice of [nature]."
    },
    "117": {
        "startTime": 864.0,
        "endTime": 867.0,
        "transcript": "Okay, we're rolling. (Rolling, rolling, okay.)",
        "translation": "Okay, we're rolling. (Rolling, rolling, okay.)"
    },
    "118": {
        "startTime": 871.7,
        "endTime": 879.6,
        "transcript": "Ak'allaat, ak'allaraat yuut imkut qanlallruut makunek nukalpianek.",
        "translation": "The people of old talked about these great hunters."
    },
    "119": {
        "startTime": 880.5,
        "endTime": 885.0,
        "transcript": "Mat'um-qaa nalliini nukalpiat enurnariut?",
        "translation": "Are there scarce any great hunters these days?"
    },
    "120": {
        "startTime": 885.5,
        "endTime": 890.2,
        "transcript": "Mat'um nalliini ayuqenrirtut nukalpiatun.",
        "translation": "These days, they're not like [traditional] great hunters."
    },
    "121": {
        "startTime": 891.5,
        "endTime": 897.0,
        "transcript": "Unugmi-llu unuakuayaarmi ayagluteng pissurayuirulluteng.",
        "translation": "And they don't go hunting at night, early in the morning, anymore."
    },
    "122": {
        "startTime": 898.0,
        "endTime": 900.5,
        "transcript": "Nukalpiacetun etenrirluteng.",
        "translation": "They're not like great hunters anymore."
    },
    "123": {
        "startTime": 900.6,
        "endTime": 906.6,
        "transcript": "Avani-wa nukalpianek pilallrullikait imkut piculriit.",
        "translation": "Back then, they probably called those who were good at catching animals great hunters."
    },
    "124": {
        "startTime": 907.0,
        "endTime": 914.8,
        "transcript": "Yuilqumun ayagluteng, ayagyara'arluteng-llu natmun yaaqvanun piyualuteng.",
        "translation": "They would travel to the wilderness, and go early to far away places on foot."
    },
    "125": {
        "startTime": 916.0,
        "endTime": 920.5,
        "transcript": "Tamakut nakellriit piculinek pilallikait.",
        "translation": "They probably referred to those who were good at catching animals great hunters."
    },
    "126": {
        "startTime": 924.8,
        "endTime": 942.5,
        "transcript": "Tua-ll' makut yuuyaraput iciw' nerangnaqsararput?",
        "translation": "And then, you know our subsistence way of life?"
    },
    "127": {
        "startTime": 943.5,
        "endTime": 950.0,
        "transcript": "Mat'um aipaimta Kass'am alerquutain tuar navgungkai.",
        "translation": "It seems that the laws of our Caucasians counterparts is destroying it."
    },
    "128": {
        "startTime": 951.9,
        "endTime": 955.5,
        "transcript": "Tamana-qaa elpeni atawaunrituq?",
        "translation": "Is that not good to you?"
    },
    "129": {
        "startTime": 956.0,
        "endTime": 967.5,
        "transcript": "Qaillun-wa tua-i navevlerarluku man'a makut Yuunrilnguut Kass'at pingengameng.",
        "translation": "It's because these Caucasians who are not Yup'ik are partially destroying it somehow."
    },
    "130": {
        "startTime": 967.6,
        "endTime": 974.5,
        "transcript": "Inerquutet-llu, inerquun-llu amlleriluki tamakut pisqevkenaki tuaten pitarkat.",
        "translation": "They even have laws against hunting too many animals."
    },
    "131": {
        "startTime": 975.0,
        "endTime": 981.0,
        "transcript": "Neqkanek-wa tua-i pitarkat inerquutekluki ilait.",
        "translation": "They have laws against [hunting] some animals we eat."
    },
    "132": {
        "startTime": 982.9,
        "endTime": 990.5,
        "transcript": "Amlleret-llu maa-i pissulriit picul'akaarqata piaqluki.",
        "translation": "And they sometimes [punish] many who catch a lot."
    },
    "133": {
        "startTime": 994.0,
        "endTime": 1009.0,
        "transcript": "Elpeni-qaa atawauyartuq wangkutnek Yug'ulriani maani nunamteńi uitalriani wangkutnek tua-i atanirtungkumta?",
        "translation": "For you, would it be good if we Yupiit who live on our lands started governing ourselves?"
    },
    "134": {
        "startTime": 1012.0,
        "endTime": 1014.5,
        "transcript": "Atanengqelalriit-wa waten:",
        "translation": "They have leaders like this:"
    },
    "135": {
        "startTime": 1014.6,
        "endTime": 1024.5,
        "transcript": "Ataniumaluteng akemkut atanret pisquciicetun atanerkaitnek pisqelluki nunat ukut",
        "translation": "They are governed by leaders from out of state who tell these villages to elect leaders"
    },
    "136": {
        "startTime": 1025.0,
        "endTime": 1029.3,
        "transcript": "Taukut-ll' allat nunat atanerkaitnek cali pisqelluki.",
        "translation": "And they tell those other villages to elect leaders too."
    },
    "137": {
        "startTime": 1030.3,
        "endTime": 1038.0,
        "transcript": "Tuaten quyurrluki ciuliqagtesqelluki picirkaitnek.",
        "translation": "They tell them to meet and govern what they should do."
    },
    "138": {
        "startTime": 1043.5,
        "endTime": 1053.5,
        "transcript": "Makut-qaa elitnaurviit maa-i-rpak elitnaurviit makut pingelriit nunani.",
        "translation": "These school that have started appearing in villages."
    },
    "139": {
        "startTime": 1054.5,
        "endTime": 1056.0,
        "transcript": "Ak'a ayagnillruyaaqut.",
        "translation": "They've already started [appearing]."
    },
    "140": {
        "startTime": 1056.9,
        "endTime": 1062.5,
        "transcript": "Elpeni-qaa ikayuutnguut Yugnun ayagyuanun?",
        "translation": "For you, are they helpful for Yup'ik youth?"
    },
    "141": {
        "startTime": 1063.4,
        "endTime": 1074.0,
        "transcript": "Ikayuutnguciiqut waten Kass'acetun qanyuilkuneng taringyuilkuneng-llu",
        "translation": "They will be helpful if they don't speak or understand English"
    },
    "142": {
        "startTime": 1075.4,
        "endTime": 1082.0,
        "transcript": "Ellaitni ikayuutngussiyaagngailan waten taringenrilkuneng qaill' picirkarteng.",
        "translation": "Because it won't be helpful if they don't understand what they should do."
    },
    "143": {
        "startTime": 1082.5,
        "endTime": 1090.0,
        "transcript": "Taringenritaqameng ayuquciitelartut qaillun tua-i tuaten picirkameggnek.",
        "translation": "When they don't understand, they don't know what to do."
    },
    "144": {
        "startTime": 1093.5,
        "endTime": 1098.0,
        "transcript": "Man'a-mi Yugcetun qaneryaraq, qalarcaraq?",
        "translation": "What about this Yup'ik language?"
    },
    "145": {
        "startTime": 1099.5,
        "endTime": 1107.5,
        "transcript": "Qalarcaraq man'a Yugcetun wangkuta, wangkuta-w' tua-i Yugcetun Yugni qallatelalriakut.",
        "translation": "Our Yup'ik language, we Yupiit speak the Yup'ik language."
    },
    "146": {
        "startTime": 1107.9,
        "endTime": 1114.0,
        "transcript": "Tua-i-ll' makut Kass'at elitnauresqelluteng wangkucicetun Yugcetun",
        "translation": "And then these Caucasians ask to be taught Yup'ik like us"
    },
    "147": {
        "startTime": 1114.8,
        "endTime": 1125.0,
        "transcript": "Wall'u mumigcitesqelluteng qanllermek mat'umek Yugmek Yugtarmek qaneryaramek.",
        "translation": "Or they ask for translations from a Yup'ik speaking the Yup'ik langauge."
    },
    "148": {
        "startTime": 1125.5,
        "endTime": 1131.0,
        "transcript": "Qaneryarallgutkenrilnguut amllerrniluki qanlalriit.",
        "translation": "They say there a lot of people who don't speak the same language."
    },
    "149": {
        "startTime": 1136.0,
        "endTime": 1149.0,
        "transcript": "Tua-ll', tua-ll'… camek ima tam' apteqataqemken ava-i?",
        "translation": "And then… what was I just going to ask you?"
    },
    "150": {
        "startTime": 1154.0,
        "endTime": 1155.9,
        "transcript": "Can you stop it for a second? I forgot what I was [going to ask].",
        "translation": "Can you stop it for a second? I forgot what I was [going to ask]."
    },
    "151": {
        "startTime": 1157.7,
        "endTime": 1162.4,
        "transcript": "Waniwa nangneqliuluku apteqataramken mat'umek:",
        "translation": "Now, this is the last question I'm going to ask you:"
    },
    "152": {
        "startTime": 1164.8,
        "endTime": 1173.8,
        "transcript": "Makut-qaa ayagyuat maani maaniunrilengraan-llu nunarrarni avatemteńi",
        "translation": "These young people from here, or even from other surrounding villages"
    },
    "153": {
        "startTime": 1174.0,
        "endTime": 1185.0,
        "transcript": "Camek elpet qanruarcuumiitaten umyuaqertellerkaatnek cam iliini wall'u-qaa watua atullerkaatnek?",
        "translation": "Do you want to tell them anything that they should remember for the future or that they would use now?"
    },
    "154": {
        "startTime": 1190.0,
        "endTime": 1195.0,
        "transcript": "Qaillun qanruyucirkaitaqa wii qanrutlerkaat.",
        "translation": "I'm not sure what I should say to them."
    },
    "155": {
        "startTime": 1195.5,
        "endTime": 1201.0,
        "transcript": "Nallunritsiyaanritaqa elisnganrilama wii.",
        "translation": "I don't really know since I'm not knowledgable."
    },
    "156": {
        "startTime": 1203.9,
        "endTime": 1214.9,
        "transcript": "Makunek-wa angayuqameggnek niitesqumaluki pisqeqernayukluki.",
        "translation": "I thought you might want them to hear something from their parents."
    },
    "157": {
        "startTime": 1215.5,
        "endTime": 1222.8,
        "transcript": "Angayuqaita-wa yut'eng inerqurarkaukait tuaten pisqevkenaki",
        "translation": "Parents must admonish their children against doing [bad] things"
    },
    "158": {
        "startTime": 1222.9,
        "endTime": 1232.0,
        "transcript": "Wall'u angayuqrunrilengraata ayagyuanrilengraata qanrutesqulluki pilaqait.",
        "translation": "Or even if they're not parents, they say they should teach them even if they're not young."
    },
    "159": {
        "startTime": 1234.0,
        "endTime": 1238.0,
        "transcript": "Man'a-qaa Yugcetun qalarcaraq atawauguq?",
        "translation": "Is speaking Yup'ik beneficial?"
    },
    "160": {
        "startTime": 1238.5,
        "endTime": 1245.0,
        "transcript": "Man'a-wa Yugcetun qalarcaraq atawaulria Yuulriani waten.",
        "translation": "This Yup'ik language is beneficial for Yupiit like this."
    },
    "161": {
        "startTime": 1247.8,
        "endTime": 1257.5,
        "transcript": "Kass'at-llu Yugcetun elitnauresqelalriit, Yuut-llu Kass'acetun elitnauresqelluteng.",
        "translation": "Caucasians ask to be taught Yup'ik, and Yupiit ask to be taght English."
    },
    "162": {
        "startTime": 1257.6,
        "endTime": 1271.5,
        "transcript": "Taumek elitnaurvingqelalriit elitnauresqumaluki-w' Yugcetun wall' Kass'acetun atunem.",
        "translation": "That's why they have school to teach both Yup'ik and English."
    },
    "163": {
        "startTime": 1273.4,
        "endTime": 1278.7,
        "transcript": "Tua-i-wa waten amllertalria apyutenka. Amllertaut waten. (Ii-i.)",
        "translation": "This is all the questions I have. This is all. (I see.)"
    },
    "164": {
        "startTime": 1279.0,
        "endTime": 1283.0,
        "transcript": "Quyana tarenraircelluten. (Yaa.)",
        "translation": "Thank you for agreeing to go on camera. (You're welcome.)"
    },
    "165": {
        "startTime": 1283.5,
        "endTime": 1286.0,
        "transcript": "Ii-i. (Quyana.) Ii-i.",
        "translation": "Okay. (Thank you.) You're welcome."
    },
    "166": {
        "startTime": 1286.5,
        "endTime": 1290.0,
        "transcript": "Una au͡g'aqerluku. Ii-i. (Akleng.) Akleng.",
        "translation": "Please take this off [of him]. There you go. (Sorry.) Poor guy."
    },
    "167": {
        "startTime": 1291.8,
        "endTime": 1294.0,
        "transcript": "Quyanaqvaa. (Quyanaqvaa.) Yaa.",
        "translation": "Thank you very much. (Thank you very much.) You're welcome."
    },
    "168": {
        "startTime": 1296.5,
        "endTime": 1298.5,
        "transcript": "Tua-i-q' [?]. (Ii-i.)",
        "translation": "Did [I] [?]. (Yes.)"
    },
    "169": {
        "startTime": 1299.6,
        "endTime": 1307.0,
        "transcript": "Tua-i elluatun qanssiyaaksaitua. (Canrituq, assirtuq.)",
        "translation": "I didn't speak very well. (It's okay, it was good.)"
    }
};